import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static values = { notificationId: Number };

  connect() {
    this.notificationIdValue = this.element.dataset.notificationIdValue;
  }

  toggleRead(event) {
    event.preventDefault();
    const url = `/notifications/${this.notificationIdValue}/toggle_read`;

    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        Accept: 'text/vnd.turbo-stream.html',
      },
    }).then((response) => {
      Turbo.visit(location.href); // Force a refresh or re-render of the page
    });
  }
}
